import type { CourseModule } from "@/core/types";
import { lektionBarrierefreiheitspruefung } from "./lektion-01-pruefung";
import { lektionDokumentschutz } from "./lektion-02-schutz";

export const modulBarrierefreiheit: CourseModule = {
  id: "barrierefreiheit",
  title: "Barrierefreiheit und Dokumentschutz",
  summary:
    "Dokumente, die alle lesen können – und die richtige Schutzstufe für die " +
    "Weitergabe.",
  level: "Aufbau",
  lessons: [lektionBarrierefreiheitspruefung, lektionDokumentschutz],
};
